export enum Row {
    LINK = "link",
    DATE = "date",
    NULL = "null"
}